import { StockItemReceiptMeasure } from './stock-item-receipt-measure';
import { StockReceiptsSalesOrderPurchaseAllocation } from './stock-receipts-sales-order-purchase-allocation';
import { StockItemAlreadyReceived } from 'tms-lib';

export interface StockItemHeaderReceipt {
  id: string;
  purchaseOrderLineId: string;
  purchaseOrderAndLineNo: string;
  supplierId: string;
  supplierAccount: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  supplierDeliveryNoteNo: string;
  externalNo: string;
  stockNo: string;
  qtyIn: number;
  qtyInImperial: number;
  valueIn: number;
  productId: string;
  productTypeDescription: string;
  productTypeHoldAtProductLevel: boolean;
  balance: number;
  pricePerUnit: number;
  warehouseId: string;
  warehouseKey: string;
  locationId: string;
  locationKey: string;
  gradeId: string;
  makeUpId: string;
  batchNo: string;
  orderQty: number;
  orderBalance: number;
  deliveryCharge: number;
  importDuty: number;
  rateOfExchange: number;
  completeOrder: boolean;
  completePercentage: number;
  orderStatus: string;
  deliveryComplete: boolean;
  imperial: boolean;
  totalPOAllocations: number;
  nearestEighth: boolean;
  numberOfLabels: number;
  orderTypeDescription: string;
  contractNo: number;
  supplierOrderNo: string;
  supplierOrderRef: string;
  quantityBase: number;
  received: number;
  receivedBase: number;
  balanceBase: number;
  price: number;
  currencyCode: string;
  uom: string;

  stockItemReceiptMeasures: StockItemReceiptMeasure[];
  stockItemsAlreadyReceived: StockItemAlreadyReceived[];
  stockReceiptsSalesOrderPurchaseAllocations: StockReceiptsSalesOrderPurchaseAllocation[];
}
